import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { updateUser } from '../services/userServices'

export function useUserUpdate() {
  const queryClient = useQueryClient()

  const {
    mutate: userUpdate,
    isLoading: isLoadingUserUpdate,
    error,
    isSuccess,
  } = useMutation({
    mutationFn: (data) => updateUser(data),
  })

  useEffect(() => {
    if (isSuccess) {
      queryClient.removeQueries({ queryKey: ['usersList'] })
      queryClient.removeQueries({ queryKey: ['userSearch'] })
    }
  }, [isSuccess, queryClient])

  return {
    userUpdate,
    isLoadingUserUpdate,
    error,
    isSuccessUserUpdate: isSuccess,
  }
}
